module.exports = __webpack_public_path__ + "static/media/credit-card-image.b396efba.png";